<template>
	<div class="sub_contents">
		<div class="cont_center">
			<h1 class="title_page">브랜드 소개</h1>

			<p class="sub_descript">
				제휴된 가맹점에서 임직원 복지카드 및 기업 패밀리카드로 결제 시 할인
				혜택을 받을 수 있는 서비스입니다.
			</p>

			<div class="brand_benefit_img">
				<img src="@/assets/images/company/brand_benefit_img.jpg" class="m_none" alt="" />
				<img src="@/assets/images/m/company/brand_benefit_img.jpg" class="pc_none" alt="" />
			</div>

			<ol class="benefit_info_list">
				<li>
					<span>01</span>

					<h3 class="title_benefit">최대 <span>20%</span> 할인</h3>

					<p class="txt_benefit">
						가맹점에 따라 <span>최소 2% ~ 최대 20%까지</span> <br />폭넓은
						청구할인 혜택을 제공
					</p>

					<p class="icon_brand_info">
						<img src="@/assets/images/company/icon_brand_info1.png" alt="" />
					</p>
				</li>
				<li>
					<span>02</span>

					<h3 class="title_benefit"><span>제한없는</span> 혜택</h3>

					<p class="txt_benefit">
						<span>전월실적 상관없이!</span> 횟수 제한없이!<br />
						할인 혜택을 제공
					</p>

					<p class="icon_brand_info">
						<img src="@/assets/images/company/icon_brand_info2.png" alt="" />
					</p>
				</li>
				<li>
					<span>03</span>

					<h3 class="title_benefit">어디서든 <span>중복할인</span></h3>

					<p class="txt_benefit">
						기존 할인 혜택이 있어도<br />
						<span>중복으로 할인 가능</span>
					</p>

					<p class="icon_brand_info">
						<img src="@/assets/images/company/icon_brand_info1.png" alt="" />
					</p>
				</li>
				<li>
					<span>04</span>

					<h3 class="title_benefit"><span>전국</span> 다양한 가맹점</h3>

					<p class="txt_benefit">
						<span>쇼핑, 문화, 여행, 외식 등</span> <br />
						생활에서 가장 자주 결제하는 곳에서<br />
						다양한 청구할인 혜택 제공
					</p>

					<p class="icon_brand_info">
						<img src="@/assets/images/company/icon_brand_info4.png" alt="" />
					</p>
				</li>
			</ol>

			<p class="title_card">
				<img src="@/assets/images/company/title_card.png" alt="복지카드 할인 쉽게 사용하세요!" />
			</p>

			<ol class="card_use_list">
				<li>
					<img src="@/assets/images/company/icon_card1.png" alt="" />

					<div class="card_use_area">
						<h3 class="title_card_use">하이비타민 가맹점 검색</h3>

						<p class="txt_card_use">
							서비스를 이용할수 있는 <br />가맹점을 검색합니다.
						</p>
					</div>
				</li>
				<li>
					<img src="@/assets/images/company/icon_card2.png" alt="" />

					<div class="card_use_area">
						<h3 class="title_card_use">복지카드 결제</h3>

						<p class="txt_card_use">
							가맹점에서 복지카드 및 <br />기업 패밀리 카드로 결제합니다.
						</p>
					</div>
				</li>
				<li>
					<img src="@/assets/images/company/icon_card3.png" alt="" />

					<div class="card_use_area">
						<h3 class="title_card_use">익월 청구 할인</h3>

						<p class="txt_card_use">익월 청구할인 내역을 확인합니다.</p>
					</div>
				</li>
			</ol>

			<!-- 제휴 브랜드 목록 이동 플로팅 버튼 (BI_002 목록 보기 버튼과 동일 스타일) -->
			<div class="btn_write_area">
				<button type="button" @click="goToBrandList" class="btn_list">제휴 브랜드 보기</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {};
	},
	methods: {
		goToBrandList() {
			this.$router.push("/HFO_BI_001");
		},
	},
};
</script>

<style lang="scss" scoped>
/* 페이지 콘텐츠가 플로팅 버튼에 가려지지 않도록 하단 여백 추가 */
.sub_contents {
	padding-bottom: 80px;
}

/* 제휴 브랜드 보기 플로팅 버튼 - HFO_BI_002 목록 보기 버튼과 동일 스타일 */
.btn_write_area {
	position: fixed;
	bottom: 20px;
	left: 0;
	right: 0;
	display: flex;
	justify-content: center;
	z-index: 9999;
	padding: 10px 0;
	pointer-events: none;
	/* 버튼 외 영역은 클릭 이벤트 통과 */
	width: 100%;
	/* 아이폰 하단 UI 메뉴 피하기 */
	padding-bottom: env(safe-area-inset-bottom, 0);
	-webkit-transform: translateZ(0);
	transform: translateZ(0);

	.btn_list {
		max-width: 260px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 12px 30px;
		background-color: #ee7527;
		color: white;
		border-radius: 30px;
		font-size: 16px;
		font-weight: 500;
		text-decoration: none;
		box-shadow: 0 4px 10px rgba(238, 117, 39, 0.3);
		transition: all 0.2s ease;
		pointer-events: auto;
		/* 버튼 자체는 클릭 가능 */
	}
}

/* 모바일 환경에서의 조정 */
@media (max-width: 1023px) {
	.btn_write_area {
		bottom: 25px;
		width: 100%;

		.btn_list {
			padding: 10px 25px;
			font-size: 14px;
			box-shadow: 0 4px 12px rgba(238, 117, 39, 0.5);
		}
	}
}
</style>
